export default "__VITE_ASSET___t_70sgS__"